import { lazy, Suspense } from "react";
import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom";

import AuthFlow from "Routes/Auth";
import AccountSuspended from "Routes/Auth/AccountSuspended";
import NotFound from "Routes/System/NotFound";
import Clients from "Routes/Clients";
import Dashboard from "Routes/Dashboard";
import RoleManager from "pages/Roles/RoleManager";
import UsersPage from "pages/Users";
import SettingsPage from "Routes/Settings";
import AuditLogsPage from "Routes/AuditLogs";
// import AnalyticsOverviewPage from "Routes/Analytics";
// import NotificationTemplatesPage from "Routes/NotificationTemplates";
import BillingOverviewPage from "Routes/Billing";
import TenantBillingPage from "Routes/Billing/TenantBilling";
import ClientModulesPage from "Routes/ClientModules";
import PayPage from "Routes/Pay";
import PayReturn from "Routes/Pay/PayReturn";
import StatementPage from "Routes/Pay/Statement";
import ProtectedRoute from "Components/ProtectedRoute";

import { Toaster } from "Components/ui";
import { AppShell } from "Components/Shell/AppShell";

// Component catalog, development builds only (see Components/ui/README.md).
const DevUiPage = lazy(() => import("Routes/DevUi"));

/** Everything behind sign-in renders inside the app shell (sidebar, top bar, Cmd+K). */
const SignedInApp = () => (
  <AppShell>
    <Switch>
      <ProtectedRoute path="/dashboard" exact component={Dashboard} />
      <ProtectedRoute
        path="/clients"
        exact
        component={Clients}
        requiredPermission={{ resource: "tenantManagement", action: "read" }}
      />
      <ProtectedRoute
        path="/clients/:tenantId/modules"
        exact
        component={ClientModulesPage}
        requiredPermission={{ resource: "tenantManagement", action: "read" }}
      />
      <ProtectedRoute
        path="/billing"
        exact
        component={BillingOverviewPage}
        requiredPermission={{ resource: "billing", action: "read" }}
      />
      <ProtectedRoute
        path="/billing/:tenantId"
        exact
        component={TenantBillingPage}
        requiredPermission={{ resource: "billing", action: "read" }}
      />
      <ProtectedRoute path="/audit-logs" exact component={AuditLogsPage} />
      {/* <ProtectedRoute
                path="/notification-templates"
                exact
                component={NotificationTemplatesPage}
                requiredPermission={{ resource: "notificationTemplates", action: "read" }}
              /> */}
      {/* <ProtectedRoute
                path="/analytics/overview"
                exact
                component={AnalyticsOverviewPage}
                requiredPermission={{ resource: "analytics", action: "read" }}
              /> */}
      <ProtectedRoute
        path="/settings"
        exact
        component={SettingsPage}
        requiredPermission={undefined}
      />
      {/* Your profile is a drawer over any page now; old links open it on Settings. */}
      <Redirect exact from="/profile" to="/settings?profile=1" />
      {/* SAP settings open in a drawer on Settings now. */}
      <Redirect exact from="/admin/settings" to="/settings?panel=sap" />
      <ProtectedRoute
        path="/hr/users"
        exact
        component={UsersPage}
        requiredPermission={{ resource: "userManagement", action: "read" }}
      />
      <ProtectedRoute
        path="/hr/roles"
        exact
        component={RoleManager}
        requiredPermission={{ resource: "roleManagement", action: "read" }}
      />
      <Route component={NotFound} />
    </Switch>
  </AppShell>
);

const Routes = () => {
  return (
    <Router>
      <Switch>
        {/* Public pay pages: no login, no shell. /pay/return must precede /pay/:token. */}
        <Route path="/pay/return" exact component={PayReturn} />
        <Route path="/pay/s/:token" exact component={StatementPage} />
        <Route path="/pay/:token" exact component={PayPage} />
        <Route path="/credentials" component={AuthFlow} />
        <Redirect from="/login" to="/credentials" />
        <Redirect from="/verify-otp" to="/credentials" />
        <Route path="/account/suspended" exact component={AccountSuspended} />
        {process.env.NODE_ENV === "development" && (
          <Route path="/dev/ui" exact>
            <Suspense fallback={null}>
              <DevUiPage />
            </Suspense>
          </Route>
        )}
        <Redirect exact from="/" to="/dashboard" />
        <ProtectedRoute render={() => <SignedInApp />} />
      </Switch>
      <Toaster />
    </Router>
  );
};

export default Routes;
